export type Difficulty = 'beginner' | 'intermediate' | 'advanced' | 'expert' | 'guru' | 'custom';

export interface QuizQuestion {
  question: string;
  options: string[];
  correct: number;
  explanation: string;
  links?: { title: string; url: string }[];
}

export interface QuizState {
  difficulty: Difficulty;
  questionCount: number;
  questions: QuizQuestion[];
  currentIndex: number;
  score: number;
  selectedAnswer: number | null;
  userAnswers: (number | null)[];
  isCompleted: boolean;
  isLoading: boolean;
  userTopic?: string;
}

export interface LessonCategory {
  icon: string;
  title: string;
  sub: string;
}

export interface LessonContent {
  title: string;
  summary: string;
  sections: {
    heading: string;
    content: string;
  }[];
  keyTakeaways: string[];
  imageUrl?: string;
  links?: { title: string; url: string }[];
}

export enum AppScreen {
  AUTH,
  START,
  TOPIC_SELECTION,
  COUNT_SELECTION,
  QUIZ,
  RESULTS,
  LESSONS,
  LESSON_VIEW,
  NEWS,
}

export interface NewsArticle {
  title: string;
  company: string;
  summary: string;
  shippingRelevance: string;
  url: string;
  date?: string;
  category: 'bigtech' | 'maritime' | 'robots';
}

export type UserRole = 'admin' | 'user';

export interface User {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  joinedAt: string;
}
